import {
  ISetupTtsPayload,
  ProjectVersionSettingsTtsActionTypes,
  IFetchProjectVersionSettingsTtsSuccessResponseBody,
  IFetchProjectVersionSettingsTtsPayload,
  IFetchTranslationLanguagesTtsPayload,
  IFetchTranslationLanguagesTtsSuccessResponseBody,
} from './types'

export const fetchProjectVersionSettingsTts = (payload: IFetchProjectVersionSettingsTtsPayload) => ({
  type: ProjectVersionSettingsTtsActionTypes.FETCH_PROJECT_VERSION_SETTINGS_TTS,
  payload
})

export const fetchProjectVersionSettingsTtsSuccess = (payload: IFetchProjectVersionSettingsTtsSuccessResponseBody) => {
  return {
    type: ProjectVersionSettingsTtsActionTypes.FETCH_PROJECT_VERSION_SETTINGS_TTS_SUCCESS,
    payload
  }
}

export const fetchProjectVersionSettingsTtsFailure = () => ({
  type: ProjectVersionSettingsTtsActionTypes.FETCH_PROJECT_VERSION_SETTINGS_TTS_FAILURE,
})

export const setupTts = (payload: ISetupTtsPayload) => ({
  type: ProjectVersionSettingsTtsActionTypes.SETUP_TTS,
  payload
})

export const setupTtsFailure = () => ({
  type: ProjectVersionSettingsTtsActionTypes.SETUP_TTS_FAILURE,
})

export const resetProjectVersionSettingsTts = () => ({
  type: ProjectVersionSettingsTtsActionTypes.RESET_PROJECT_VERSION_SETTINGS_TTS,
})

export const fetchTranslationLanguagesTts = (payload: IFetchTranslationLanguagesTtsPayload) => ({
  type: ProjectVersionSettingsTtsActionTypes.FETCH_TRANSLATION_LANGUAGES_TTS,
  payload,
})

export const fetchTranslationLanguagesTtsSuccess = (payload: IFetchTranslationLanguagesTtsSuccessResponseBody) => ({
  type: ProjectVersionSettingsTtsActionTypes.FETCH_TRANSLATION_LANGUAGES_TTS_SUCCESS,
  payload,
})

export const fetchTranslationLanguagesTtsFailure = () => ({
  type: ProjectVersionSettingsTtsActionTypes.FETCH_TRANSLATION_LANGUAGES_TTS_FAILURE,
})

export const resetTranslationLanguagesTts = () => ({
  type: ProjectVersionSettingsTtsActionTypes.RESET_TRANSLATION_LANGUAGES_TTS,
})
